import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { T } from "@/i18n";
import { Check, Trash, Undo } from "lucide-react";
import { useState } from "react";
import { Day, useTourDaysContext } from "./context";
import { Services } from "./services";
import { Accommodations } from "./accommodations";

export function TourDayDetails({ day }: { day: Day }) {
  const { updateDayName, deleteDay } = useTourDaysContext();
  return (
    <div className="grid gap-4">
      <div className="flex items-center justify-between gap-2">
        <Name
          value={day.tourDay.value.name}
          onChange={(nm) => {
            updateDayName(day.tourDay.value.day, nm);
          }}
        />
        <Button
          variant="text-destructive"
          size="icon"
          className="m-1"
          onClick={() => deleteDay(day.tourDay.value.day)}
        >
          <Trash />
          <span className="sr-only">
            <T tKey="tourDays.day.delete" />
          </span>
        </Button>
      </div>
      <Accommodations
        tourId={day.tourDay.value.tourId}
        day={day.tourDay.value.day}
        accommodations={day.accommodations.map(({ value }) => value)}
      />
      <Services
        tourId={day.tourDay.value.tourId}
        day={day.tourDay.value.day}
        services={day.services.map(({ value }) => value)}
      />
    </div>
  );
}

function Name({
  value,
  onChange,
}: {
  value: string | null | undefined;
  onChange: (nm: string) => void;
}) {
  const [name, setName] = useState<string | null | undefined>(value);
  const [edit, setEdit] = useState(false);

  if (!edit) {
    return (
      <Button
        variant="text"
        type="button"
        className="m-1 w-fit p-0"
        onClick={() => setEdit(true)}
      >
        <T tKey="tourDays.day.updateName" />
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Input
        id="name"
        className="w-2/5"
        value={name ?? value ?? ""}
        onChange={(ev) => {
          setName(ev.target.value);
        }}
      />
      <Button
        disabled={name === value}
        variant="text"
        type="button"
        className="m-1 w-fit"
        onClick={() => {
          onChange(name ?? "");
          setEdit(false);
        }}
      >
        <Check />
      </Button>
      <Button
        variant="text-destructive"
        type="button"
        className="m-1 w-fit"
        onClick={() => {
          setName(value);
          setEdit(false);
        }}
      >
        <Undo />
      </Button>
    </div>
  );
}
